import type { RouteObject } from 'react-router-dom';
import MarketplaceHome from '../pages/MarketplaceHome';

export const homeRoutes: RouteObject[] = [
  { path: '/', element: <MarketplaceHome /> },
  { path: '/search', element: <div>Search Results (TODO)</div> },
];
